function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-password-field/~/@babel/runtime/helpers/builtin/interopRequireDefault.js
// module id = 276
// module chunks = 0